import { render, staticRenderFns } from "./DisputeSubmitForm.vue?vue&type=template&id=26b3bc3b&scoped=true"
import script from "./DisputeSubmitForm.vue?vue&type=script&lang=js"
export * from "./DisputeSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./DisputeSubmitForm.vue?vue&type=style&index=0&id=26b3bc3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3bc3b",
  null
  
)

export default component.exports